import { Navigate, useLocation, useSearchParams } from 'react-router-dom';
import { getSingleModel } from '../utils/helpers';
import { dispatch } from '../redux/store';
import DownloadAppBanner from '../components/reusable/DownloadAppBanner';

const AuthRoute = ({ element, ...rest }) => {
    const location = useLocation();
    const query = useSearchParams()[0];

    const isAuthenticated = () => {
        return getSingleModel('auth')?.authUser?.authenticated;
    };

    if (query.get('id')) {
        dispatch.auth.logout();
    }

    const from = location.state?.from?.pathname || '/';

    const excludedRoutes = [];
    const showBanner = !excludedRoutes.includes(location.pathname);

    if (isAuthenticated()) {
        return <Navigate to={from} replace />;
    }

    return (
        <>
            {showBanner && <DownloadAppBanner />}
            <div className={showBanner ? 'mt-[40px]' : ''}>{element}</div>
        </>
    );
};

export default AuthRoute;
